"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var react_1 = __importDefault(require("react"));
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var InputWrapper_1 = require("../InputWrapper/InputWrapper");
var Input_1 = require("../Input/Input");
function Textarea(_a) {
    var _b = _a.autosize, autosize = _b === void 0 ? false : _b, maxRows = _a.maxRows, minRows = _a.minRows, label = _a.label, error = _a.error, description = _a.description, id = _a.id, className = _a.className, required = _a.required, themeOverride = _a.themeOverride, style = _a.style, wrapperProps = _a.wrapperProps, inputStyle = _a.inputStyle, elementRef = _a.elementRef, others = __rest(_a, ["autosize", "maxRows", "minRows", "label", "error", "description", "id", "className", "required", "themeOverride", "style", "wrapperProps", "inputStyle", "elementRef"]);
    var uuid = hooks_1.useId(id);
    var theme = theme_1.useMantineTheme(themeOverride);
    return (react_1.default.createElement(InputWrapper_1.InputWrapper, __assign({ label: label, error: error, id: uuid, description: description, required: required, style: style, className: className }, wrapperProps), autosize ? (react_1.default.createElement(Input_1.Input, __assign({ required: required, component: react_textarea_autosize_1.default, invalid: !!error, maxRows: maxRows, minRows: minRows, id: uuid, elementRef: elementRef, inputStyle: __assign(__assign({ paddingTop: theme.spacing.xs, paddingBottom: theme.spacing.xs }, inputStyle), { height: undefined }) }, others))) : (react_1.default.createElement(Input_1.Input, __assign({ component: "textarea", required: required, id: uuid, invalid: !!error, rows: minRows, elementRef: elementRef, inputStyle: __assign({ paddingTop: theme.spacing.xs, paddingBottom: theme.spacing.xs }, inputStyle) }, others)))));
}
exports.Textarea = Textarea;
Textarea.displayName = '@mantine/core/Textarea';
